import Vue from 'vue'
import LendingCalculator from './lending-calculator'
import FormCalc from './form-calc'
import AutoCurrency from './auto-currency'

if (document.getElementById('vueLendingCalculator')) {
  new Vue({
    el: '#vueLendingCalculator',
    components: {
      LendingCalculator
    },
  })
}

if (document.getElementById('vueFormCalc')) {
  new Vue({
    el: '#vueFormCalc',
    components: {
      FormCalc
    },
  })
}

if (document.getElementById('vueAutoCurrency')) {
  new Vue({
    el: '#vueAutoCurrency',
    components: {
      AutoCurrency
    },
  })
}
